import React, { Component } from 'react'
import Item from './Item'
import { extendParentClass } from '../../../../../../utils/classes'

export class Icons extends Component {
  baseClass = extendParentClass.bind(this)('icons-list')

  icons = [
    {
      title: 'Pixel perfect',
      url: 'https://www.flaticon.com/authors/pixel-perfect',
    },
    {
      title: 'Becris',
      url: 'https://www.flaticon.com/authors/becris',
    },
    {
      title: 'Freepik',
      url: 'https://www.flaticon.com/authors/freepik',
    },
    {
      title: 'Good Ware',
      url: 'https://www.flaticon.com/authors/good-ware',
    },
  ]

  renderItem = (iconData, index) => (
    <Item {...iconData} key={index} parentClass={this.baseClass} />
  )

  renderItems = () => this.icons.map(this.renderItem)

  render() {
    return <ul className={this.baseClass}>{this.renderItems()}</ul>
  }
}

export default Icons
